<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-12">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                            class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>
        <b-row class="d-flex">
            <b-col sm="12" md="12">
                <div role="group" class="form-group text-label" style="float: left; width: 21%;">
                    <b-form-checkbox v-model="requisicao.deduzirPagamentos" id="deduzirPagamentos" name="check-button"
                                     class="mt-2" switch @input="iniciarDeducoes" style="float: left;"
                                     :disabled="requisicao.titularReceita == 1 && requisicao.formaPagamento != 1">
	                    Deduzir pgto(s) anteriores
                    </b-form-checkbox>
                    <b-form-checkbox v-model="requisicao.boletoValorCerto" id="boletoValorCerto" name="check-button"
                                     class="mt-2" switch style="float: left;" @input="iniciarValorCerto();">
                        Boleto de Valor Certo
                    </b-form-checkbox>
                </div>
                <b-form-group
                        label="Percentual (%):"
                        label-for="variacao"
                        class="text-label required"
                        style="float: left; max-width: 10%; margin-left: 1%;"
                        v-if="!requisicao.boletoValorCerto">
                    <b-form-input v-model="requisicao.percentual" type="text" @change="trocarPercentual();"
                                  :disabled="requisicao.pagamento && requisicao.pagamento.percentualHonorario > 0"
                                  @keyup="requisicao.percentual = formatarDecimalPositivo(requisicao.percentual, 3, 4)"
                    />
                </b-form-group>
	            <b-form-group
		            label="Valor Certo (R$):"
		            label-for="valor"
		            class="text-label required"
		            style="float: left; max-width: 10%; margin-left: 1%;"
	                v-if="requisicao.boletoValorCerto">
		            <b-form-input v-model="requisicao.valorCerto" type="text" id="valor" @change="validarValor"
		                          :class="!validations.valor.valid ? 'is-invalid' : ''"
		                          @keyup="requisicao.valorCerto = formatarMonetario(requisicao.valorCerto)"/>
		            <div v-if="!validations.valor.valid" class="invalid-message">Valor Certo deve ser maior que zero.</div>
	            </b-form-group>
                <b-form-group
                        label="Modalidade de Pagamento:"
                        label-for="variacao"
                        class="text-label required modalidadePagamento"
                        style="float: left; max-width: 22%; margin-left: 1%;">

                    <b-form-select v-model="requisicao.pagamento" @change="mudarPagamento();obterQuantidadeParcelas();"
                                   :disabled="requisicao.boletoValorCerto">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.regrasPagamento"
                                :key="tc.codPagamento"
                                :value="tc">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                    
                </b-form-group>
                <b-form-group
                        label="N° de Parcelas:"
                        label-for="numeroParcelas"
                        class="text-label required"
                        style="float: left; max-width: 15%; margin-left: 1%;"
                        v-if="requisicao.pagamento && requisicao.pagamento.parcelas">
                    <b-form-select v-model="requisicao.numeroParcelas" class="mb-3">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.parcelas"
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.text }}
                        </option>
                    </b-form-select>
                </b-form-group>
                <b-form-group
                        label="Informe o N° de Parcelas:"
                        label-for="valorFixo"
                        class="text-label required"
                        style="float: left; max-width: 15%; margin-left: 1%;"
                        v-if="requisicao.pagamento && !requisicao.pagamento.aVista && !requisicao.pagamento.parcelas">
                    <b-form-input v-model="requisicao.numeroParcelas" type="text" id="valorFixo"
                                  @keyup="requisicao.numeroParcelas = formatarDecimal(requisicao.numeroParcelas, 3, 0)"></b-form-input>
                </b-form-group>
                <b-form-group
                        label="Índice de Reajuste das Parcela:"
                        label-for="valorindica"
                        class="text-label required"
                        style="float: left; max-width: 16%; margin-left: 1%;"
                        v-if="requisicao.pagamento && !requisicao.pagamento.aVista">
                    <b-form-select v-model="requisicao.indiceReajuste" class="mb-3">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                                v-for="tc in dados.indiceReajuste"
                                :key="tc.codIndice"
                                :value="tc.codIndice">
                            {{ tc.descricao }}
                        </option>
                    </b-form-select>
                </b-form-group>
                <b-form-group
                        label="Forma de Pagamento:"
                        label-for="formapagamento"
                        class="text-label required"
                        style="float: left; max-width: 15%; margin-left: 1%;">
                    <b-form-select v-model="requisicao.formaPagamento" :disabled="requisicao.boletoValorCerto">
                        <option
                                v-for="tc in formaPagamentoTitular()" 
                                :key="tc.id"
                                :value="tc.id">
                            {{ tc.nome ? tc.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="mb-0" v-if="requisicao.pagamento && requisicao.pagamento.delibSid">
            <div role="group" class="form-group text-label" style="float: left; width: 21.5%;">
            </div>
            <b-col sm="12" md="2">
                <b-form-group
                    label="Nº Deliberação Conselho:"
                    label-for="valorindica"
                    class="text-label required deliberacao">
                    <b-form-input v-model="requisicao.deliberacao" type="text" maxlength="50" id="valorFixo"
                                  :class="!validationsTela.deliberacao.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validationsTela.deliberacao.valid" class="invalid-message">{{validationsTela.deliberacao.message}}</div>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group
                    label="SID:"
                    label-for="valorindica"
                    class="text-label required">
                    <b-form-input v-model="requisicao.sid" type="text" maxlength="50" id="valorFixo"
                                  :class="!validationsTela.sid.valid ? 'is-invalid' : ''"/>
                    <div v-if="!validationsTela.sid.valid" class="invalid-message">{{validationsTela.sid.message}}</div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="d-flex justify-content-between">
            <b-col>
                <b-button
                        id="btnAnteriorCalculos"
                        class="mr-2"
                        @click="$emit('prevTab')"
                        variant="secondary"
                        style="height: 40px;" >
                    <i class="fa fa-arrow-left"></i> Anterior
                </b-button>
                <CompBotaoExibirOcultarColuna
                        :fields="fields"
                        :showColunms="showColunms"
                        @toggleColuna="toggleColuna"/>
                <b-button
                        id="btnRelatorioDeducoes"
                        class="ml-2"
                        variant="outline-warning"
                        style="height: 40px;"
                        v-b-modal.modal-deducoes
                        :disabled="!requisicao.deduzirPagamentos">
                    <i class="fa fa-eye"></i> Ver Relatório de Deduções
                </b-button>
            </b-col>
            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                              :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                              v-if="configTable.perPage != 'Todos'">
                </b-pagination>
            </b-col>
            <b-col class="text-right">
                <b-button
                    id="btnRelatorioSimulacaoCalculo"
                    class="ml-2 my-2"
                    variant="outline-secondary"
                    style="height: 40px; margin-top: 10px;"
                    @click="relatorioPDFSimulacaoCalculo"
                    :disabled="requisicao.cdas.length === 0 || configTable.load">
                    <i class="fa fa-print"></i>
                </b-button>
                <b-button class="ml-2 my-2" variant="secondary" @click="limparFiltros(false)"
                          style="margin-right: 10px; height: 40px; padding: 0 0.75rem;">
                    <i class="fas fa-broom"></i> Limpar Filtros
                </b-button>
                <b-form-select v-model="configTable.perPage" :options="[250, 500, 1000, 'Todos']" size="sm"
                               class="col-2" style="height: 40px;"></b-form-select>
                <b-button v-if="!existeHonorariosMenorValorPendente"
                          class="ml-2" id="btnProximaCalculos"
                          @click="$emit('nextStep')"
                          :disabled="!validarObrigatorios || configTable.load || existePgtoParcialAntesAjuizamento"
                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
                <b-button v-else
                          class="ml-2" id="btnProximaCalculos"
                          @click="$bvModal.show('modal-honorarios-menor')"
                          :disabled="!validarObrigatorios || configTable.load || existePgtoParcialAntesAjuizamento"
                          variant="primary" style="height: 40px;">
                    Próxima
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-table :items="itemsTable"
                :fields="fields"
                striped
                small
                responsive="sm"
                :busy="configTable.load"
                show-empty
                hover
                bordered
                class="mb-0"
                head-variant="light">
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Nenhuma CDA encontrada.</p>
            </template>
            <template v-slot:head(0)="{ item }">
                CDA <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.numeroDivida) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA', 'mascara', '', '##########', $event)"></i>
            </template>
            <template v-slot:cell(0)="{ item }">
                <p class="coluna-resize text-center">
                    <a class="link" @click="abrirModalExtratoCda(item.numeroDivida, item.codOrgaoOrigemDivida)">
                        {{ item.numeroDivida }}
                    </a>
                </p>
            </template>
            <template v-slot:head(1)="{ item }">
                REFIS Ativo <i class="filter" :class="!isEmpty(filtros.refisAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('REFIS Ativo', 'radio', 'N,S', null, $event)"></i>
            </template>
            <template v-slot:cell(1)="{ item }">
                <p class="coluna-resize text-center">
                    {{ item.refisAtivo }}
                </p>
            </template>
            <template v-slot:head(2)="{ item }">
                CDA Valor Pendente (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPendente) || filtros.filtrarValorPendente == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('CDA Valor Pendente (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(2)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorPendente)">
                    {{ item.valorPendente | currency }}
                </p>
            </template>
            <template v-slot:head(3)="{ item }">
                Valor Base Principal (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPrincipal) || filtros.filtrarValorPrincipal == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Base Principal (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(3)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBasePrincipal) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorBasePrincipal | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(4)="{ item }">
                Valor Base Multa (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorMulta) || filtros.filtrarValorMulta == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Base Multa (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(4)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBaseMulta) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorBaseMulta | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(5)="{ item }">
                Juros Inscrito (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorJuros) || filtros.filtrarValorJuros == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Juros Inscrito (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(5)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorJuros) && requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.valorJuros | currency }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(6)="{ item }">
                Data Base Principal <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.dataBasePrincipal) || filtros.filtrarDataBasePrincipal == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Base Principal', 'dataCurta', '', null, $event)"></i>
            </template>
            <template v-slot:cell(6)="{ item }">
                <p class="coluna-resize text-center" v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.dataBasePrincipal }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(7)="{ item }">
                Data Base Multa <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.dataBaseMulta) || filtros.filtrarDataBaseMulta == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Base Multa', 'dataCurta', '', null, $event)"></i>
            </template>
            <template v-slot:cell(7)="{ item }">
                <p class="coluna-resize text-center" v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir">
                    {{ item.dataBaseMulta }}
                </p>
                <p class="coluna-resize text-right" v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                    -
                </p>
            </template>
            <template v-slot:head(8)="{ item }">
                Base Honorários (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorBase) || filtros.filtrarValorBase == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Base Honorários (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(8)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorBaseHonorarios)" 
                    :class="item.valorBaseHonorarios > item.valorPendente ? 'text-warning' : ''"
                    :style="item.valorBaseHonorarios < item.valorPendente ? 'color: red' : ''" >
                    {{ item.valorBaseHonorarios | currency }}
                </p>
            </template>
            <template v-slot:head(9)="{ item }">
                Perc. Pago (%) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPercentualPago) || filtros.filtrarValorPercentualPago == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Perc. Pago (%)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(9)="{ item }">
                <p class="coluna-resize text-right" :style="item.percentualPago > 0 ? 'color: red' : ''" v-if="requisicao.deduzirPagamentos && !item.valorHonorariosFixo">
                    {{ item.percentualPago | currency }} %
                </p>
                <p class="coluna-resize text-right" v-if="item.valorHonorariosFixo">
                    -
                </p>
            </template>
            <template v-slot:head(10)="{ item }">
                Perc. Pend. (%) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorPercentual) || filtros.filtrarValorPercentual == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Perc. Pend. (%)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(10)="{ item }">
                <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.percentual) && !item.valorHonorariosFixo">
                    {{ (item.percentual > item.percentualPago ? calcularPercentualPendente(item) : 0) | currency }} %
                </p>
                <p class="coluna-resize text-right" v-if="item.valorHonorariosFixo">
                    -
                </p>
            </template>
            <template v-slot:head(11)="{ item }">
                Valor dos Honorários (R$) <i class="coluna-fixa-calculos filter" :class="!isEmpty(filtros.valorHonorarios) || filtros.filtrarValorHonorarios == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor dos Honorários (R$)', 'numerico', '', null, $event)"></i>
            </template>
            <template v-slot:cell(11)="{ item }">
                <div class="text-right" style="color:red" v-if="item.pgtoParcialAntesAjuizamento">
                    <i class="fa fa-exclamation-triangle"></i>
                </div>
                <div v-else>
                    <p class="coluna-resize text-right" v-if="!verificarValorVazio(item.valorHonorarios) && item.valorHonorarios >= 0">
                        {{ item.valorHonorarios | currency }}
                    </p>
                    <div class="text-right" v-if="verificarValorVazio(item.valorHonorarios) || item.valorHonorarios < 0">
                        <i title="Editar os valores da CDA e recalcular os honorários" class="fas fa-exclamation-triangle text-danger"></i>
                    </div>
                </div>
            </template>
            <template v-slot:head(12)="{ item }">
                <div class="d-flex justify-content-between align-items-center">
                    <span>Edit.</span>
                    <i class="fas fa-info-circle fa-12x text-info" variant="info"
                       v-b-modal.modal-info-edit
                       v-b-popover.hover.top="'Clique para Detalhes'"></i>
                </div>
            </template>
            <template v-slot:cell(12)="{ item }">
                <div class="text-center">
                    <b-button variant="link" @click="abrirModalEditar(item)">
                        <i class="fa fa-calculator"></i>
                    </b-button>
                </div>
            </template>
        </b-table>

        <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
            <b-col class="col-md-5">
            </b-col>
            <b-col style="display: flex; justify-content: center;" class="col-md-3">
            </b-col>
            <b-col class="col-md-4 text-right">
                <div class="input-group input-group-md mb-2">
                    <div style="float: right;width: 100%;">
                        <span class="input-group-text" :style="'float: right;' + (totalHonorarios() <= 0 ? 'color: red;' : '')">
                            <b>Total (R$):&nbsp;</b>
                            {{totalHonorarios() | currency}}
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <CompLoading ref="loadingTabela"/>

        <b-modal
                ref="modal-deduzir"
                id="modal-deduzir"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title='Cuidados ao utilizar a função "Deduzir pagamento(s) anterior(es)"'
                header-bg-variant="info"
                header-text-variant="white"
                @close="fecharModalAvisoDeducoes"
                @hide="fecharModalAvisoDeducoes">
            <p>A opção "Deduzir pagamento(s) anterior(es)" ligada fará com que valores pagos em Requisições anteriores registradas no sistema, quitadas ou rescindidas (que indicam pagamento total ou parcial), em que conste a CDA selecionada, sejam deduzidos do cálculo de honorários.</p>
	        <p>Contudo, quando a geração de uma nova Requisição com a opção "Deduzir pagamento(s) anterior(es)" ligada puder ou tiver que recuperar e utilizar guias geradas no antigo sistema de Guias do Fundo, em razão da enorme quantidade de inconsistências geradas ao longo dos anos na alimentação do antigo sistema, RECOMENDA-SE ao usuário a realização ou a conferência do cálculo de deduções visto que, exatamente em razão das incongruências da base de dados apontadas, pagamentos realizados no sistema antigo PODEM NÃO SER RECONHECIDOS pelo SFEPGE, especialmente devido a:</p>
	        <p>- geração de guia no antigo sistema sem as informações necessárias para a correta vinculação no SFEPGE;</p>
	        <p>- geração de guia no antigo sistema com informações erradas;</p>
	        <p>- geração de guia no antigo sistema sem o apontamento de uma ou de todas as CDAs que integram aquela guia;</p>
	        <p>- geração de guia no antigo sistema sem o valores base das CDAs ao tempo da geração da guia;</p>
	        <p>- etc.</p>
            <p>Todos esses problemas prejudicam ou impossibilitam a correta identificação e a vinculação da guia gerada no antigo sistema, assim demandando a pesquisa e a conferência manual por parte do usuário do SFEPGE ao utilizar a funcionalidade "Deduzir pagamento(s) anterior(es)".</p>

            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-deduzir')"> Ciente e continuar com o cálculo de dedução</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-deduzir-ces"
                id="modal-deduzir-ces"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title='Cuidados ao utilizar a função "Deduzir pagamento(s) anterior(es)"'
                header-bg-variant="info"
                header-text-variant="white"
                @close="fecharModalAvisoDeducoes"
                @hide="fecharModalAvisoDeducoes">
            <p>A opção "Deduzir pagamento(s) anterior(es)" ligada fará com que valores pagos em Requisições anteriores registradas no sistema, quitadas ou rescindidas (que indicam pagamento total ou parcial), em que conste a CDA selecionada, sejam deduzidos do cálculo de honorários.</p>
	        <p>Contudo, quando a geração de uma nova Requisição com a opção "Deduzir pagamento(s) anterior(es)" ligada puder ou tiver que recuperar e utilizar guias geradas nos sistemas da CES (ex.: COBMAIS), em razão da ausência de integração com aqueles sistemas RECOMENDA-SE ao usuário a realização manual do cálculo de deduções com os dados obtidos junto à CES.</p>
	        <p>Vale também destacar que transferências realizadas diretamente para a conta bancária da CES somente são aferíveis mediante análise individual do caso concreto pela CES, sendo que o atual sistema SFEPGE não conta com essa informação em sua base de dados.</p>

            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-deduzir-ces')"> Ciente e continuar com o cálculo de dedução</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-info-edit"
                id="modal-info-edit"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários ou informar o seu próprio valor de honorários devidos."
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li style="text-align: justify;">
                            Para alterar os valores decompostos da dívida indicados na grid e utilizados no cálculo dos honorários pelo sistema ou para informar um valor de
                            honorários manualmente calculado, clique no ícone <i class="fas fa-calculator text-primary"></i> da linha correspondente para abrir a tela de
                            edição da dívida, onde poderão ser informados os seus corretos valores decompostos (através do preenchimento das colunas “Valor Base Principal”,
                            “Valor Base Multa”, “Juros Inscritos”, “Data Base Principal” e “Data Base Multa”) ou, alternativamente, o próprio valor global manualmente atualizado
                            a ser considerado pelo sistema (através do preenchimento da coluna “Base Honorários”) ou, ainda, o próprio valor de honorários devidos para a CDA
                            manualmente calculado.</li>
                        <li style="text-align: justify;">
                            Sendo exibido o ícone <i class="fas fa-exclamation-triangle text-danger"></i> na coluna “Valor dos Honorários”, para a geração da Requisição de
                            Honorários para a CDA ajuizada em questão é obrigatória a edição conforme um dos métodos descritos acima.
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-edit')"> Fechar</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-info-error"
                id="modal-info-error"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            Para um ou mais protestos exibidos na grid, o sistema falhou ao tentar
                            calcular os honorários de protesto. Para esses casos, sinalizados na
                            grid com o ícone
                            <i class="fas fa-exclamation-triangle text-danger"></i> na coluna "Valor
                            dos Honorários", clique no ícone
                            <i class="fas fa-calculator text-primary"></i> da linha correspondente
                            para abrir a tela de edição da dívida, onde deverão ser informados os
                            seus corretos valores decompostos (colunas "Valor Base Principal",
                            "Valor Base Multa", "Juros Inscritos", "Data Base Principal" e "Data
                            Base Multa") ou, alternativamente, o próprio valor global manualmente
                            atualizado a ser considerado pelo sistema (coluna "Base Calculada").
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-error')"> Fechar</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-editar"
                id="modal-editar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Editar os valores da CDA e recalcular os honorários ou o seu próprio valor de honorários devidos"
                header-bg-variant="success"
                header-text-variant="white">
            <b-form-group label>
                <b-form-radio-group
                        id="radio-group"
                        v-model="tipoEditar"
                        class="radio-filter">
                    <b-form-radio value="0">
                        Editar os valores decompostos da CDA ou o seu valor global:
                    </b-form-radio>
                    <b-row class="mt-3" v-if="tipoEditar == 0">
                        <b-col xs="12" md="12" class="mx-auto">
                            <p>Informe os valores decompostos da dívida e as datas de atualização para que o próprio sistema atualize o valor global da dívida e recalcule os honorários da CDA ajuizada a partir dos novos parâmetros ou, alternativamente, informe diretamente o valor global da dívida atualizado manualmente no campo da última coluna Base Honorários:</p>
                        </b-col>
                    </b-row>
                    <b-table :fields="fieldsEditar"
                             :items="itemEdicao"
                             striped
                             small
                             responsive="sm"
                             show-empty
                             hover
                             bordered
                             class="mb-0"
                             v-if="tipoEditar == 0"
                             head-variant="light">
                        <template v-slot:cell(numeroCda)="{ item }">
                            <input type="text" readonly="readonly" :value="item.numeroDivida"
                                   class="font-weight-bold form-control-plaintext text-center">
                        </template>
                        <template v-slot:cell(valorBase)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.valorBasePrincipal" type="text"
                                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                                              :class="'text-right ' + (!validations.valorBasePrincipal.valid || !validations.valorBasePrincipal.required ? 'is-invalid' : '')"
                                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                                              @keyup="item.valorBasePrincipal = formatarMonetarioForcar(item.valorBasePrincipal)">
                                </b-form-input>
                                <b-form-input type="text" :disabled="true"
                                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                                </b-form-input>
                                <div v-if="!validations.valorBasePrincipal.valid" class="invalid-message">Valor inválido!</div>
                            </b-form-group>
                        </template>
                        <template v-slot:cell(valorMulta)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.valorBaseMulta" type="text"
                                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                                              :class="'text-right ' + (!validations.valorBaseMulta.valid || !validations.valorBaseMulta.required ? 'is-invalid' : '')"
                                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                                              @keyup="item.valorBaseMulta = formatarMonetarioForcar(item.valorBaseMulta)">
                                </b-form-input>
                                <b-form-input type="text" :disabled="true"
                                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                                </b-form-input>
                                <div v-if="!validations.valorBaseMulta.valid" class="invalid-message">Valor inválido!</div>
                            </b-form-group>
                        </template>
                        <template v-slot:cell(juros)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.valorJuros" type="text"
                                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                                              :class="'text-right ' + (!validations.valorJuros.valid ? 'is-invalid' : '')"
                                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)" @change="validarEdicaoItem"
                                              @keyup="item.valorJuros = formatarMonetarioForcar(item.valorJuros)">
                                </b-form-input>
                                <b-form-input type="text" :disabled="true"
                                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                                </b-form-input>
                                <div v-if="!validations.valorJuros.valid" class="invalid-message">Valor inválido!</div>
                            </b-form-group>
                        </template>
                        <template v-slot:cell(dataBase)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.dataBasePrincipal" type="text" @change="validarEdicaoItem"
                                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                                              :class="!validations.dataBasePrincipal.valid || !validations.dataBasePrincipal.required ? 'is-invalid' : ''"
                                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)"
                                              v-mask="['##/####']">
                                </b-form-input>
                                <b-form-input type="text" :disabled="true"
                                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                                </b-form-input>
                                <div v-if="!validations.dataBasePrincipal.valid" class="invalid-message">Data inválida!</div>
                            </b-form-group>
                        </template>
                        <template v-slot:cell(dataMulta)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.dataBaseMulta" type="text" @change="validarEdicaoItem"
                                              v-if="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir"
                                              :class="!validations.dataBaseMulta.valid || !validations.dataBaseMulta.required ? 'is-invalid' : ''"
                                              :disabled="!verificarValorVazio(item.valorBaseHonorarios)"
                                              v-mask="['##/####']">
                                </b-form-input>
                                <b-form-input type="text" :disabled="true"
                                              v-if="requisicao.pagamento != null && requisicao.pagamento.valorPendenteFir">
                                </b-form-input>
                                <div v-if="!validations.dataBaseMulta.valid" class="invalid-message">Data inválida!</div>
                            </b-form-group>
                        </template>
                        <template v-slot:cell(baseHonorarios)="{ item }">
                            <b-form-group>
                                <b-form-input v-model="item.valorBaseHonorarios" type="text" @change="validarEdicaoItem"
                                              :class="'text-right ' + (!validations.valorBaseHonorarios.valid ? 'is-invalid' : '')"
                                              :disabled="requisicao.pagamento != null && !requisicao.pagamento.valorPendenteFir &&
                                (!verificarValorVazio(item.valorBasePrincipal) || !verificarValorVazio(item.valorBaseMulta) || !verificarValorVazio(item.valorJuros)
                                || !verificarValorVazio(item.dataBasePrincipal) || !verificarValorVazio(item.dataBaseMulta))"
                                              @keyup="item.valorBaseHonorarios = formatarMonetarioForcar(item.valorBaseHonorarios)">
                                </b-form-input>
                                <div v-if="!validations.valorBaseHonorarios.valid" class="invalid-message">Valor inválido!</div>
                            </b-form-group>
                        </template>
                    </b-table>

                    <b-form-radio value="1">
                        Editar o valor de honorários devido da CDA
                    </b-form-radio>
                    <b-row class="mt-3" v-if="tipoEditar == 1">
                        <b-col xs="12" md="12" class="mx-auto">
                            <p>Informe o valor de honorários da dívida para que o sistema substitua na grid principal o valor lá calculado pelo valor aqui informado:</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-table :fields="fieldsEditarValor"
                                     :items="itemEdicao"
                                     striped
                                     small
                                     responsive="sm"
                                     show-empty
                                     hover
                                     bordered
                                     class="mb-0"
                                     v-if="tipoEditar == 1"
                                     head-variant="light">
                                <template v-slot:cell(numeroCda)="{ item }">
                                    <input type="text" readonly="readonly" :value="item.numeroDivida"
                                           class="font-weight-bold form-control-plaintext text-center">
                                </template>
                                <template v-slot:cell(valorHonorarios)="{ item }">
                                    <b-form-group>
                                        <b-form-input v-model="item.valorHonorarios" type="text"
                                                      :class="'text-right ' + (!validations.valorHonorarios.valid || !validations.valorHonorarios.required ? 'is-invalid' : '')"
                                                      @change="validarEdicaoItem"
                                                      @keyup="item.valorHonorarios = formatarMonetarioForcar(item.valorHonorarios)">
                                        </b-form-input>
                                        <div v-if="!validations.valorHonorarios.valid" class="invalid-message">Valor inválido!</div>
                                    </b-form-group>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-form-radio-group>
            </b-form-group>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hideModal('modal-editar')"> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="salvarRecalcular" :disabled="!editarValido" class="mr-2"> <i class="fas fa-save"></i> Salvar e Recalcular</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-deducoes"
                id="modal-deducoes"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Relatório de Deduções"
                header-bg-variant="success"
                header-text-variant="white"
                @hidden="hideModal('modal-deducoes')">
            <template #modal-header="{ hide }">
                <h5 class="modal-title">Relatório de Deduções</h5>
                <b-button variant="success" @click="relatorioPDFDeducoes" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="hide()" aria-label="close">&times;</button>
            </template>

            <b-col style="display: flex; justify-content: center;">
                <b-pagination v-model="configTableDeducoes.currentPage" :per-page="configTableDeducoes.perPage"
                              :total-rows="configTableDeducoes.rows" size="sm" style="padding: 0 !important; margin: 0 !important;"
                              v-if="configTableDeducoes.perPage != 'Todos'">
                </b-pagination>
                <b-form-select v-model="configTableDeducoes.perPage" :options="[10, 100, 500]" size="sm"
                               class="col-1 ml-3" style="height: 31px;"></b-form-select>
            </b-col>

            <b-card v-if="configTableDeducoes.load" class="card-accordion text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </b-card>

            <b-card v-if="!configTableDeducoes.load && deducoes.resultado != null && deducoes.resultado.length == 0" class="card-accordion text-center text-primary my-2">
                <p class="my-auto">Nenhuma dedução encontrada.</p>
            </b-card>

            <b-card v-if="!configTableDeducoes.load && deducoes.resultado != null && deducoes.resultado.length > 0" v-for="deducao in deducoes.resultado" class="card-accordion mb-1" >
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button v-b-toggle="'accordion' + deducao.id" class="btn-block botao" @click="deducao.expandido = !deducao.expandido">
                        <b-row class="d-flex justify-content-between">
                            <b-col md="2" :style="(deducao.guiaDefeito ? 'color: red;' : '')">
                                CDA: {{deducao.cda}}
                            </b-col>
                            <b-col md="2" :style="(deducao.guiaDefeito ? 'color: red;' : '')">
                                - Req.: {{deducao.requisicao}}
                            </b-col>
                            <b-col md="2" :style="(deducao.guiaDefeito ? 'color: red;' : '')">
                                - Data Pgto.: {{deducao.dataPagamento}}
                            </b-col>
                            <b-col md="2" :style="(deducao.guiaDefeito ? 'color: red;' : '')">
                                - Pgto. Req.: {{deducao.valorPago | currency}}
                            </b-col>
                            <b-col md="3" v-if="!deducao.guiaDefeito">
                                - Pgto. CDA.: {{deducao.valorPagoCda | currency}}
                            </b-col>
                            <b-col md="3" v-if="deducao.guiaDefeito" style="color: red">
                                - Pgto. CDA.: ???
                            </b-col>
                            <b-col md="1" style="float: right">
                                <button class="btn btn-link" v-if="!deducao.expandido" aria-label="close"><i class="far fa-plus-square text-secondary"></i></button>
                                <button class="btn btn-link" v-if="deducao.expandido" aria-label="close"><i class="far fa-minus-square text-secondary"></i></button>
                            </b-col>
                        </b-row>
                    </b-button>
                </b-card-header>
                <b-collapse v-bind:id="'accordion' + deducao.id" class="mt-2">
                    <b-card>
                        <b-col md="12">
                            <b-table :fields="fieldsDeducao"
                                     :items="deducao.cdas"
                                     striped
                                     small
                                     responsive="sm"
                                     show-empty
                                     hover
                                     bordered
                                     class="mb-0"
                                     head-variant="light">
                                <template v-slot:cell(cda)="{ item }">
                                    <p class="coluna-resize text-center" :style="(item.destaque ? 'font-weight: bold;' : '') + (item.guiaDefeito ? 'color: red;' : '')">
                                        {{item.cda}}
                                    </p>
                                </template>
                                <template v-slot:cell(honorariosCda)="{ item }">
                                    <p class="coluna-resize text-right" :style="(item.destaque ? 'font-weight: bold;' : '') + (item.guiaDefeito ? 'color: red;' : '')">
                                        {{ item.honorariosCda | currency }}
                                    </p>
                                </template>
                                <template v-slot:cell(rateio)="{ item }">
                                    <p v-if="!item.guiaDefeito" class="coluna-resize text-right" :style="(item.destaque ? 'font-weight: bold;' : '')">
                                        {{item.rateio | currency}}
                                    </p>
                                    <p v-if="item.guiaDefeito" class="coluna-resize text-right" :style="(item.destaque ? 'font-weight: bold; color: red;' : 'color: red;')">
                                        ???
                                    </p>
                                </template>
                                <template v-slot:cell(valorAtualizado)="{ item }">
                                    <p v-if="!item.guiaDefeito" class="coluna-resize text-right" :style="(item.destaque ? 'font-weight: bold;' : '')">
                                        {{item.valorAtualizado | currency}}
                                    </p>
                                    <p v-if="item.guiaDefeito" class="coluna-resize text-right" :style="(item.destaque ? 'font-weight: bold; color: red;' : 'color: red;')">
                                        ???
                                    </p>
                                </template>
                            </b-table>
                        </b-col>
                    </b-card>
                </b-collapse>
            </b-card>

            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click="hide()"> <i class="fa fa-reply"></i> Voltar</b-button>
                <b-button variant="outline-secondary" @click="expandirTudo()"> <i class="far fa-plus-square"></i> Expandir tudo</b-button>
                <b-button variant="outline-secondary" @click="recolherTudo()"> <i class="far fa-minus-square"></i> Recolher tudo</b-button>
            </template>
        </b-modal>

        <b-modal
            ref="modal-barra-progresso"
            id="modal-barra-progresso"
            size="xs"
            :content-class="'shadow ' + getTheme"
            title="Atualização de deduções em andamento"
            header-bg-variant="success"
            header-text-variant="white"
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            hide-header-close>
          <b-row class="mt-3">
            <b-col xs="12" md="12" class="mx-auto">
              <ul>
                <li>
                  Os cálculos de deduções estão em andamento. Por favor <strong>aguarde</strong>.
                </li>
                <li>
                  Andamento dos cálculos:
                  <b-progress :value="calculosRealizados" :max="maximoCalculos" animated></b-progress>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-modal>

        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="!existeRegistro">Para o mês/ano imediatamente anterior ao informado nos campos “Mês” e “Ano” não consta registro de variação cadastrada no sistema para o índice em questão. Dessa forma, antes de realizar o cadastro da variação do índice para o mês informado, retorne à tela anterior e efetue o cadastro da variação do índice relativo ao mês/ano anterior.</p>
                    <p style="font-weight: bold;" v-if="existeRegistro">Para o mês/ano informado nos campos “Mês” e “Ano” já consta registro de variação cadastrada no sistema para o índice em questão. Ao confirmar esse novo cadastrado, a variação anteriormente cadastrada para o mês/ano informado será substituída pela variação informada.</p>
                    <p style="font-weight: bold;" v-if="existeRegistro">Deseja confirmar a alteração da variação do índice para o mês/ano informado?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')" v-if="!existeRegistro"> Voltar</b-button>
                <b-button variant="secondary" @click="hide('modal-salvar')" v-if="existeRegistro"> Não</b-button>
                <b-button variant="primary" @click="salvar" v-if="existeRegistro"> Sim</b-button>
            </template>
        </b-modal>

        <b-modal
                ref="modal-honorarios-menor"
                id="modal-honorarios-menor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Atenção! Possível dívida ativa retificada após o ajuizamento!"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>No presente cálculo, consta(m) dívida(s) ativa(s) com possível retificação após o ajuizamento da execução fiscal. Ao clicar em "Avançar", o usuário concorda com a desconsideração no cálculo dessa(s) eventual(is) retificação(ões). Caso alguma(s) retificação(ões) tenha(m) de ser considerada(s), o cálculo de atualização da dívida deverá ser realizado manualmente pelo usuário e inserido no sistema (ícone calculadora).</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <b-button variant="secondary" @click="$bvModal.hide('modal-honorarios-menor')"> Voltar</b-button>
                <b-button variant="primary" @click="$bvModal.hide('modal-honorarios-menor'); $emit('nextStep')"> Avançar</b-button>
            </template>
        </b-modal>

        <b-modal
            ref="modal-mensagem-cda"
            id="modal-mensagem-cda"
            size="xl"
            :content-class="'shadow ' + getTheme"
            title="ALERTA DE PAGAMENTO PARCIAL OCORRIDO ANTES DO AJUIZAMENTO!"
            header-bg-variant="info"
            header-text-variant="white">

            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>Para as CDAs identificadas na grid com o ícone <i class="fa fa-exclamation-triangle" style="color: red;"></i>, constam registros que indicam possível pagamento parcial ocorrido antes da data do ajuizamento das respectivas execuções fiscais. Para essas CDAs, o usuário deverá verificar nos processos judiciais o exato valor que foram ajuizadas e alterar o valor “Base Honorários” de cada uma delas através do ícone botão <i class="fa fa-calculator" style="color: #0073C0;"></i> contido na última coluna da grid.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="$bvModal.hide('modal-mensagem-cda')">Retornar à grid para editar as CDAs com alerta de pagamento</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";
    import CompLoading from "../../shared/components/CompLoading";

    export default {
    props: ['devedor', 'cdasSelecionadas', 'requisicao'],
    components: {CompBotaoExibirOcultarColuna, CompLoading},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.consultar(false);
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.consultar(false);
        },
        currentPageDeducoes() {
            this.configTableDeducoes.checkedAll = false;
            this.consultarDeducoes();
        },
        perPageDeducoes() {
            this.configTableDeducoes.currentPage = 1;
            this.consultarDeducoes();
        },
        'requisicao.titularReceita': function () {
            this.listarRegrasPagamento();
        },
        'requisicao.formaPagamento': function () {
            if (this.requisicao.titularReceita == 1 && this.requisicao.formaPagamento != 1) {
                this.requisicao.deduzirPagamentos = false;
            }
        }
    },
    data() {
        return {
            existeRegistro: null,
            urlApi: null,
            token: null,
            tipoEditar: 0,
            calculoEmAndamento: 0,
            onLoad: false,
            onLoadDeducoes: false,
            existePgtoParcialAntesAjuizamento: false,
            existeHonorariosMenorValorPendente: false,
            dados: {
                regrasPagamento: null,
                indiceReajuste: null,
                formaPagamento: [
                    {
                        id: 1,
                        nome: 'Boleto'
                    },
                    {
                        id: 3,
                        nome: 'Cobrança CES'
                    }
                ],
                parcelas: null
            },
            filtros: {
                numeroDivida: null,
                forcarRefisAtivo: null,
                idTipoRefis: null,
                refisAtivo: null,
                filtrarValorPendente: null,
                valorPendente: null,
                filtrarValorPrincipal: null,
                valorPrincipal: null,
                filtrarValorMulta: null,
                valorMulta: null,
                filtrarValorJuros: null,
                valorJuros: null,
                filtrarDataBasePrincipal: null,
                dataBasePrincipal: null,
                filtrarDataBaseMulta: null,
                dataBaseMulta: null,
                filtrarValorBase: null,
                valorBase: null,
                filtrarValorHonorarios: null,
                valorHonorarios: null,
                filtrarValorPercentualPago: null,
                valorPercentualPago: null,
                filtrarValorPercentual: null,
                valorPercentual: null,
            },
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                listaValores: []
            },
            fields: [],
            configTable: {
                perPage: 250,
                lastPage: null,
                sortField: 'numerodivida',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            configTableDeducoes: {
                perPage: 10,
                lastPage: null,
                currentPage: 1,
                rows: 0,
                load: false,
                iniciada: false,
            },
            currentScroll: null,
            showColunms: [],
            totalHonorariosAntigo: null,
            delayParcelas: false,
            itemEdicao: [],
            deducoes: [],
            fieldsEditar: [
                {
                    key: 'numeroCda',
                    label: 'CDA'
                },
                {
                    key: 'valorBase',
                    label: 'Valor Base Principal'
                },
                {
                    key: 'valorMulta',
                    label: 'Valor Base Multa'
                },
                {
                    key: 'juros',
                    label: 'Juros Inscrito'
                },
                {
                    key: 'dataBase',
                    label: 'Data Base Principal'
                },
                {
                    key: 'dataMulta',
                    label: 'Data Base Multa'
                },
                {
                    key: 'baseHonorarios',
                    label: 'Base Honorários'
                },
            ],
            fieldsEditarValor: [
                {
                    key: 'numeroCda',
                    label: 'CDA'
                },
                {
                    key: 'valorHonorarios',
                    label: 'Valor de Honorários'
                }
            ],
            fieldsDeducao: [
                {
                    key: 'cda',
                    label: 'CDA'
                },
                {
                    key: 'honorariosCda',
                    label: 'Honorários por CDA (R$)'
                },
                {
                    key: 'rateio',
                    label: 'Rateio do Pgto. por CDA (R$)'
                },
                {
                    key: 'valorAtualizado',
                    label: 'Pgto. Atualizado (R$)'
                }
            ],
            validations: {
                valorBasePrincipal: {
                    valid: true,
                    required: true
                },
                valorBaseMulta: {
                    valid: true,
                    required: true
                },
                valorJuros: {
                    valid: true
                },
                valorBaseHonorarios: {
                    valid: true
                },
                dataBasePrincipal: {
                    valid: true,
                    required: true
                },
                dataBaseMulta: {
                    valid: true,
                    required: true
                },
                valorHonorarios: {
                    valid: true,
                    required: true
                },
                valor: {
                    valid: true,
                    required: true
                }
            },
            validationsTela: {
                deliberacao: { valid: true, message: '' },
                sid: { valid: true, message: '' },
            },
            indiceMap: new Map(),
            indiceList: [],
            subListaFiltro: [],
            calculosRealizados: 0,
            maximoCalculos: 0
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
        currentPageDeducoes() {
            return this.configTableDeducoes.currentPage;
        },
        perPageDeducoes() {
            return this.configTableDeducoes.perPage;
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        itemsTable() {
            let filterItems = [];
            for(let i = 0; i < this.subListaFiltro.length; i++) {
                if (this.requisicao.pagamento && this.requisicao.pagamento.refis) {
                    if (this.subListaFiltro[i].idTipoRefis.includes(this.filtros.idTipoRefis.toString()) && this.subListaFiltro[i].refisAtivo === 'S') {
                        filterItems.push (this.subListaFiltro[i])
                    }
                }
                else {
                    filterItems.push (this.subListaFiltro[i])
                }

            }
            this.requisicao.cdas = filterItems;
            return filterItems;
        },
        validarObrigatorios() {
            if(this.requisicao.percentual == null || this.requisicao.percentual == '') {
                return false;
            }
            if(this.requisicao.pagamento == null) {
                return false;
            }
            if(!this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas && this.requisicao.numeroParcelas == null) {
                return false;
            }
            if(!this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas && this.requisicao.indiceReajuste == null) {
                return false;
            }
            if(this.totalHonorarios() <= 0) {
                return false;
            }
            if(this.requisicao.pagamento && this.requisicao.pagamento.delibSid) {
                if(this.verificarValorVazio(this.requisicao.deliberacao)) {
                    return false;
                }
                if(this.verificarValorVazio(this.requisicao.sid)) {
                    return false;
                }
            }

			if(this.calculoEmAndamento > 0) {
				return false;
			}

			if(this.requisicao.boletoValorCerto) {
				let valor = this.tratarCamposNumericos(this.requisicao.valorCerto)
				if(this.isEmpty(valor) || valor <= 0) {
					this.validations.valor.valid = false;
					return false;
				} else {
					this.validations.valor.valid = true;
				}
			}

            return true;
        },
        // eslint-disable-next-line vue/return-in-computed-property
        editarValido() {
            if(this.tipoEditar == 0) {
                return this.validations.valorBasePrincipal.valid && this.validations.valorBasePrincipal.required
                    && this.validations.valorBaseMulta.valid && this.validations.valorBaseMulta.required
                    && this.validations.valorJuros.valid && this.validations.valorBaseHonorarios.valid
                    && this.validations.dataBasePrincipal.valid && this.validations.dataBasePrincipal.required
                    && this.validations.dataBaseMulta.valid && this.validations.dataBaseMulta.required
                    && ((this.itemEdicao[0].valorBaseHonorarios != null && this.itemEdicao[0].valorBaseHonorarios != '') ||
                        (this.itemEdicao[0].dataBaseMulta != null && this.itemEdicao[0].dataBaseMulta != '') ||
                        (this.itemEdicao[0].dataBasePrincipal != null && this.itemEdicao[0].dataBasePrincipal != '') ||
                        (this.itemEdicao[0].valorJuros != null && this.itemEdicao[0].valorJuros != '') ||
                        (this.itemEdicao[0].valorBaseMulta != null && this.itemEdicao[0].valorBaseMulta != '') ||
                        (this.itemEdicao[0].valorBasePrincipal != null && this.itemEdicao[0].valorBasePrincipal != ''));
            } else if(this.tipoEditar == 1) {
                return this.validations.valorHonorarios.valid;
            }
        },
    },
    methods: {
        async listarRegrasPagamento() {
            axios.get(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/listarRegrasPagamento/${this.requisicao.titularReceita}`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.regrasPagamento = response.data;

                if(this.requisicao.pagamento == null) {
                    this.atribuirRegraPagamento();
                }
            })
        },
        atribuirRegraPagamento() {
            if (this.dados.regrasPagamento) {
                for(let i = 0; i < this.dados.regrasPagamento.length; i++) {
					if(this.dados.regrasPagamento[i].descricao.trim().toUpperCase().includes('À VISTA')) {
                        this.requisicao.pagamento = this.dados.regrasPagamento[i];

                        if(this.requisicao.pagamento.percentualHonorario != null
                            && this.requisicao.pagamento.percentualHonorario > 0) {
                            this.requisicao.percentual = this.requisicao.pagamento.percentualHonorario;
                        } else {
                            this.requisicao.percentual = 10;
                        }
                    }
					break;
                }
            }
        },
        atribuirPagamentoRequisicao() {
            if(this.requisicao.pagamento != null) {
                this.dados.regrasPagamento.forEach(value => {
                    if(value.codPagamento == this.requisicao.pagamento.codPagamento) {
                        this.requisicao.pagamento = value;
                    }
                });

                this.obterQuantidadeParcelas();

                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.requisicao.cdas[i].percentual = this.requisicao.pagamento.percentualHonorario;
                    this.requisicao.cdas[i].valorHonorarios = this.requisicao.cdas[i].valorBaseHonorarios * (this.requisicao.cdas[i].percentual/100);
                }
            }
        },
        async listarIndiceReajuste() {
            axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarIndiceReajuste`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.indiceReajuste = response.data
            })
        },
        async obterColunasUsuario() {
            const funcionalidade = 'honorariosExecucaoFiscalSefaCdaCalculo';

            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i)
                    }
                    this.fields.push({
                        key: `${i}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },
        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
        async consultarComScroll(primeira) {
            this.currentScroll = document.documentElement.scrollTop;
            this.consultar(primeira);
        },
        async trocarPercentual() {
          if(this.requisicao.percentual <= 0) {
            this.requisicao.percentual = "";
          } else {
            this.consultar(false);
          }
        },
        async consultar(primeira) {
            if(!this.onLoad) {
                this.onLoad = true;
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

				let percentual = this.requisicao.boletoValorCerto ? 10 : this.tratarCamposNumericosFloat(this.requisicao.percentual);

                if(primeira) {
                    this.filtros.listaCdaSefaCalculoEfSefaVO = [];
                    for (let j = 0; j < this.cdasSelecionadas.length; j++) {
                        this.filtros.listaCdaSefaCalculoEfSefaVO.push({
                            codCdaSefa: this.cdasSelecionadas[j].codCdaSefa,
                            codProcesso: this.cdasSelecionadas[j].codProcesso,
                            dataAjuizamento: this.cdasSelecionadas[j].dataAjuizamento,
                            dataBasePrincipal: this.cdasSelecionadas[j].dataBasePrincipal,
                            dataBaseMulta: this.cdasSelecionadas[j].dataBaseMulta,
                            valorPendente: this.cdasSelecionadas[j].valor,
                            valorBasePrincipal: this.cdasSelecionadas[j].valorBasePrincipal,
                            valorBaseMulta: this.cdasSelecionadas[j].valorBaseMulta,
                            valorJuros: this.cdasSelecionadas[j].valorJuros,
                            dataBasePrincipalAtual: this.cdasSelecionadas[j].dataBasePrincipalAtual,
                            dataBaseMultaAtual: this.cdasSelecionadas[j].dataBaseMultaAtual,
                            valorBasePrincipalAtual: this.cdasSelecionadas[j].valorBasePrincipalAtual,
                            valorBaseMultaAtual: this.cdasSelecionadas[j].valorBaseMultaAtual,
                            valorJurosAtual: this.cdasSelecionadas[j].valorJurosAtual,
                            tipoCredito: this.cdasSelecionadas[j].tipoCredito,
                            situacao: this.cdasSelecionadas[j].situacao,
                            numeroDivida: this.cdasSelecionadas[j].numeroDivida,
                            refisAtivo: this.cdasSelecionadas[j].refisAtivo,
                            cnj: this.cdasSelecionadas[j].cnj,
                            calculoManual: this.cdasSelecionadas[j].calculoManual,
                            percentual: percentual,
                            listaHonorariosExecucaoFiscalSefa: this.cdasSelecionadas[j].listaHonorariosExecucaoFiscalSefa
                        });
                    }
                } else {
                    for (let j = 0; j < this.requisicao.cdas.length; j++) {
                        this.requisicao.cdas[j].percentual = percentual;
                    }
                    this.filtros.listaCdaSefaCalculoEfSefaVO = this.requisicao.cdas;
                }

                this.filtros.deduzirPagamentos = this.requisicao.deduzirPagamentos;
                this.filtros.listaCodFichaProcesso = [];
                for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                    this.filtros.listaCodFichaProcesso.push(this.cdasSelecionadas[i].codCdaSefa);
                }

                this.filtros.forcarRefisAtivo = null;
                this.filtros.idTipoRefis = this.requisicao.pagamento ? this.requisicao.pagamento.codPagamento : null;
                this.filtros.buscarDataAtualMainframe = this.requisicao.pagamento != null && this.requisicao.pagamento.deducoesPendente;

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/consultarCdaValores?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if (response.data.atualizacaoPagamentoComplexa) {
                      this.showModal('modal-barra-progresso');
                      this.maximoCalculos = 100;
                      this.calculosRealizados = 0;
                      setTimeout(() => {
                        this.atualizarBarraProgresso(response.data.futureName);
                      }, 1000);
                    } else {
                      if (this.requisicao.deduzirPagamentos) {
                        this.consultarDeducoes();
                      }

                      this.hideModal('modal-barra-progresso');
                      this.configTable.load = false;
                      this.onLoad = false;
                      this.$emit('atribuirListaCda', response.data.resultadoCompleto);
                      this.$nextTick(() => {
                        let subLista = [];

                        for (let i = 0; i < this.requisicao.cdas.length; i++) {
							this.calculoEmAndamento += 1;
                            this.calcularValorBaseHonorarios(this.requisicao.cdas[i], true);
                        }

                        this.existePgtoParcialAntesAjuizamento = false;
                        this.existeHonorariosMenorValorPendente = false;

                        for(let j = 0; j < response.data.pagina.resultado.length; j++) {
                          for (let i = 0; i < this.requisicao.cdas.length; i++) {
                            if(response.data.pagina.resultado[j].codCdaSefa == this.requisicao.cdas[i].codCdaSefa) {
                              subLista.push(this.requisicao.cdas[i]);
                              
                              if (response.data.pagina.resultado[j].pgtoParcialAntesAjuizamento) {
                                this.existePgtoParcialAntesAjuizamento = true;
                              }
                              break;
                            }
                          }
                        }



                        if (this.existePgtoParcialAntesAjuizamento) {
                            this.$bvModal.show('modal-mensagem-cda');
                        }

                        this.subListaFiltro = subLista;

                        this.carregarValoresConsulta(response.data.pagina.rows);
                      });
                    }
                }).catch((error) => {
                    this.exibirErro(error);
                    this.configTable.load = false;
                    this.onLoad = false;
                })
            }
        },
        carregarValoresConsulta(rows) {
            if (this.configTable.perPage !== 'Todos') {
                this.configTable.rows = rows;
                this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
            } else {
                this.configTable.lastPage = 1;
            }

            if (this.currentScroll != null) {
                setTimeout(() => {
                    document.documentElement.scrollTop = this.currentScroll;
                    this.currentScroll = null;
                }, 100);
            }
        },
        totalHonorarios() {
            let total = 0;
            for(let i = 0; i < this.requisicao.cdas.length; i++) {
                if((this.requisicao.pagamento && !this.requisicao.pagamento.refis) || this.requisicao.cdas[i].refisAtivo == 'S') {
                    total += this.requisicao.cdas[i].valorHonorarios == null ? 0 : this.requisicao.cdas[i].valorHonorarios;
                }
            }

            if(total != this.totalHonorariosAntigo) {
                if(!this.delayParcelas) {
                    this.delayParcelas = true;
                    setTimeout(()=>{
                        this.obterQuantidadeParcelas();
                        this.delayParcelas = false;
                    }, 500);
                }
                this.totalHonorariosAntigo = total;
                this.requisicao.totalRequisicao = total;
            }

            return total;
        },
        async calcularValorBaseHonorarios(item, flagCalculo) {
            if(this.requisicao.pagamento && this.requisicao.pagamento.refis && item.refisAtivo == 'N') {
				if(flagCalculo) {
					this.calculoEmAndamento -= 1;
				}
                return;
            }

            let juros = item.valorJuros != null && item.valorJuros > 0;

            let valorJuros = item.valorJuros != null ? item.valorJuros : 0;

            if((item.baseHonorariosFixo == null || !item.baseHonorariosFixo) && (item.valorHonorariosFixo == null || !item.valorHonorariosFixo)) {
                if(item.valorBaseHonorarios == null && this.requisicao.pagamento != null && this.requisicao.pagamento.valorPendenteFir) {
                    item.valorBaseHonorarios = item.valorPendente;
                } else if(!this.verificarValorVazio(item.valorBasePrincipal) || !this.verificarValorVazio(item.valorBaseMulta) || !this.verificarValorVazio(item.valorJuros)
                    || !this.verificarValorVazio(item.dataBasePrincipal) || !this.verificarValorVazio(item.dataBaseMulta)) {
                    let valorBasePrincipal = item.valorBasePrincipal != null ? item.valorBasePrincipal : 0;
                    let valorBaseMulta = item.valorBaseMulta != null ? item.valorBaseMulta : 0;

                    if(item.dataBasePrincipal != null && item.dataBasePrincipal != '' && !item.dataBasePrincipal.startsWith('00') && !item.dataBasePrincipal.endsWith('0000')) {
                        let valorCorrecao = await this.calcularDadosSelic(item.dataBasePrincipal, valorBasePrincipal, juros);

                        if(valorCorrecao != null) {
                            valorBasePrincipal = valorCorrecao;
                        }
                    }

                    if(item.dataBaseMulta != null && item.dataBaseMulta != '' && !item.dataBaseMulta.startsWith('00') && !item.dataBaseMulta.endsWith('0000')) {
                        let valorCorrecao = await this.calcularDadosSelic(item.dataBaseMulta, valorBaseMulta, juros);

                        if(valorCorrecao != null) {
                            valorBaseMulta = valorCorrecao;
                        }
                    }

                    item.valorBaseHonorarios = this.toFixed(valorBasePrincipal + valorBaseMulta + (juros ? valorJuros : 0));
                    item.valorBaseHonorarios = Math.round(item.valorBaseHonorarios * 100) / 100;

                    if(this.requisicao.pagamento && (this.requisicao.pagamento.deducoes
                            || this.requisicao.pagamento.deducoesPendente)) {
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualDescontoJuros)
                            && this.requisicao.pagamento.percentualDescontoJuros > 0) {
                            let valorJurosIsolado = this.toFixed(item.valorBaseHonorarios - item.valorBaseMulta - item.valorBasePrincipal);
                            valorJurosIsolado = this.toFixed(valorJurosIsolado * (this.requisicao.pagamento.percentualDescontoJuros / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - valorJurosIsolado);
                        }
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualPrincipal)
                            && this.requisicao.pagamento.percentualPrincipal > 0) {
                            let descontoValorBasePrincipal = this.toFixed(item.valorBasePrincipal * (this.requisicao.pagamento.percentualPrincipal / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - descontoValorBasePrincipal);
                        }
                        if(!this.verificarValorVazio(this.requisicao.pagamento.percentualDescontoMulta)
                            && this.requisicao.pagamento.percentualDescontoMulta > 0
                            && item.valorBaseMulta != null) {
                            let descontoValorBaseMulta = this.toFixed(item.valorBaseMulta * (this.requisicao.pagamento.percentualDescontoMulta / 100));

                            item.valorBaseHonorarios = this.toFixed(item.valorBaseHonorarios - descontoValorBaseMulta);
                        }

                        item.valorBaseHonorarios = Math.round(item.valorBaseHonorarios * 100) / 100;
                    }
                }
            }

            if(this.requisicao.deduzirPagamentos && item.guiaDefeito && (item.calculoManual == null || !item.calculoManual)) {
                item.percentualPago = 0;
                item.valorHonorarios = null;
            } else {
                if((item.valorHonorariosFixo == null || !item.valorHonorariosFixo) && item.valorBaseHonorarios != null && item.percentual != null) {
                    if(item.valorDeduzido != null && item.valorDeduzido > 0) {
                        item.percentualPago = this.toFixed(item.valorDeduzido * 100);
                        item.percentualPago = this.toFixed(item.percentualPago / item.valorBaseHonorarios);
                    } else {
                        item.percentualPago = 0;
                    }

                    let percentual = item.percentual - (item.percentualPago != null ? item.percentualPago : 0);
                    if(percentual <= 0) {
                        item.valorHonorarios = 0;
                    } else {
                        item.valorHonorarios = this.toFixed(item.valorBaseHonorarios * (percentual/100));
                        item.valorHonorarios = Math.round(item.valorHonorarios * 100) / 100;
                    }
                }
            }

	        if(flagCalculo) {
		        this.calculoEmAndamento -= 1;
	        }

            if (item.valorBaseHonorarios < item.valorPendente) {
                this.existeHonorariosMenorValorPendente = true;
            }

        },

        async calcularDadosSelic(dataBase, valor, juros) {
            let key = parseInt(juros ? moment(dataBase, "MM/YYYY").add(1, 'M').format("YYYYMM") :
                moment(dataBase, "MM/YYYY").format("YYYYMM"));
            let percentuais = 0;

	        for (var i = 0; i < this.indiceList.length; i++) {
				if (parseInt(this.indiceList[i].data) < key) {
					break;
				}
                percentuais = this.toFixed(percentuais + this.indiceList[i].variacao);
            }

			if (percentuais == 0) {
				return null;
			}

            var valorTemp = this.toFixed(parseFloat(valor) * ((percentuais + 1) / 100));
            valor = this.toFixed(valor + valorTemp);
            valor = Math.floor(valor * 100) / 100;
            return valor;
        },

        mudarPagamento() {
            if(this.requisicao.pagamento != null) {
                this.requisicao.numeroParcelas = null;

                if(this.requisicao.pagamento.percentualHonorario != null
                    && this.requisicao.pagamento.percentualHonorario > 0) {
                    this.requisicao.percentual = this.requisicao.pagamento.percentualHonorario.toString().replace(".", ",");
                } else {
                    this.requisicao.percentual = 10;
                }

                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.requisicao.cdas[i].percentual = this.requisicao.percentual;
                    this.requisicao.cdas[i].valorHonorarios = this.requisicao.cdas[i].valorBaseHonorarios * (this.requisicao.cdas[i].percentual/100);
                }

                this.requisicao.indiceReajuste = null;

                for (var i = 0; i < this.dados.indiceReajuste.length; i++) {
                    if (this.dados.indiceReajuste[i].codIndice == this.requisicao.pagamento.codIndiceSugerir) {
                        this.requisicao.indiceReajuste = this.requisicao.pagamento.codIndiceSugerir;
                    }
                }

                this.consultarComScroll(true);
            }
        },
        obterQuantidadeParcelas() {
            this.dados.parcelas = [];
            if(this.requisicao.pagamento && !this.requisicao.pagamento.aVista && this.requisicao.pagamento.parcelas) {
                let valorTotal = 0;
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    if((this.requisicao.pagamento && !this.requisicao.pagamento.refis) || this.requisicao.cdas[i].refisAtivo == 'S') {
                        valorTotal += this.requisicao.cdas[i].valorHonorarios == null ? 0 : this.requisicao.cdas[i].valorHonorarios;
                    }
                }

                axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/obterNumeroParcelas/${this.requisicao.pagamento.codPagamento}`, valorTotal, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        let valorParcela = valorTotal;

                        for(var i = response.data.minimo; i <= response.data.maximo; i++) {
                            let valorParcela = (valorTotal/i).toFixed(2);
                            if(valorParcela >= response.data.valorMinimoParcela) {
                                let valorParcelaString = (valorTotal/i).toFixed(2).toString().replace('.', ',');
                                valorParcelaString =  valorParcela.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                                this.dados.parcelas.push({
                                    id: i,
                                    text: i + ' X - R$ ' + valorParcelaString + ' + correção'
                                });
                            }
                        }

                        this.requisicao.pagamento.percentualDescontoJuros = response.data.percentualDescontoJuros;
                        this.requisicao.pagamento.percentualDescontoMulta = response.data.percentualDescontoMulta;
                        this.requisicao.pagamento.percentualPrincipal = response.data.percentualPrincipal;

                        for(let i = 0; i < this.requisicao.cdas.length; i++) {
                            this.calcularValorBaseHonorarios(this.requisicao.cdas[i], false);
                        }
                    }
                });
            } else {
                for(let i = 0; i < this.requisicao.cdas.length; i++) {
                    this.calcularValorBaseHonorarios(this.requisicao.cdas[i], false);
                }
            }
        },
        abrirModalEditar(item) {
            let copyItem = {
                codCdaSefa: item.codCdaSefa,
                dataBaseMulta: item.dataBaseMulta,
                dataBasePrincipal: item.dataBasePrincipal,
                dataEnvio: item.dataEnvio,
                numeroDivida: item.numeroDivida,
                percentual: item.percentual,
                refisAtivo: item.refisAtivo,
                valorBaseHonorarios: this.formatarMonetarioSemCasa(item.valorBaseHonorarios),
                valorBaseMulta: this.formatarMonetarioSemCasa(item.valorBaseMulta),
                valorBasePrincipal: this.formatarMonetarioSemCasa(item.valorBasePrincipal),
                valorHonorarios: this.formatarMonetarioSemCasa(item.valorHonorarios),
                valorJuros: this.formatarMonetarioSemCasa(item.valorJuros),
                valorPendente: item.valorPendente
            };

            if(this.requisicao.pagamento != null && !this.requisicao.pagamento.valorPendenteFir &&
                (!this.verificarValorVazio(item.valorBasePrincipal) || !this.verificarValorVazio(item.valorBaseMulta) || !this.verificarValorVazio(item.valorJuros)
                    || !this.verificarValorVazio(item.dataBasePrincipal) || !this.verificarValorVazio(item.dataBaseMulta))) {
                copyItem.valorBaseHonorarios = null;
            }

            this.itemEdicao = [copyItem];

            this.reiniciarValidations();

            this.tipoEditar = item.valorHonorariosFixo ? 1 : 0;

            this.showModal('modal-editar');
        },
        validarEdicaoItem() {
            let item = this.itemEdicao[0];
	        this.validations = {
		        valorBasePrincipal: {
			        valid: true,
			        required: true
		        },
		        valorBaseMulta: {
			        valid: true,
				        required: true
		        },
		        valorJuros: {
			        valid: true
		        },
		        valorBaseHonorarios: {
			        valid: true
		        },
		        dataBasePrincipal: {
			        valid: true,
			        required: true
		        },
		        dataBaseMulta: {
			        valid: true,
			        required: true
		        },
		        valorHonorarios: {
			        valid: true,
			        required: true
		        },
		        valor: {
			        valid: true,
			        required: true
		        }
	        };
            if(!this.verificarValorVazio(item.valorBasePrincipal) && this.tratarCamposNumericosFloat(item.valorBasePrincipal) <= 0) {
                this.validations.valorBasePrincipal.valid = false;
            }
            if(!this.verificarValorVazio(item.valorBaseMulta) && this.tratarCamposNumericosFloat(item.valorBaseMulta) <= 0) {
                this.validations.valorBaseMulta.valid = false;
            }
            if(!this.verificarValorVazio(item.valorJuros) && this.tratarCamposNumericosFloat(item.valorJuros) <= 0) {
                this.validations.valorJuros.valid = false;
            }
            if(!this.verificarValorVazio(item.valorBaseHonorarios) && this.tratarCamposNumericosFloat(item.valorBaseHonorarios) < 0) {
                this.validations.valorBaseHonorarios.valid = false;
            }

            if(!this.verificarValorVazio(item.dataBasePrincipal) && moment(item.dataBasePrincipal, "MM/YYYY") != undefined
                && (!moment(item.dataBasePrincipal, "MM/YYYY").isValid()
                    || !moment(item.dataBasePrincipal, "MM/YYYY").isBetween('1901-01-01', moment())
                    || item.dataBasePrincipal.length < 7)) {
                this.validations.dataBasePrincipal.valid = false;
            }
            if(!this.verificarValorVazio(item.dataBaseMulta) && moment(item.dataBaseMulta, "MM/YYYY") != undefined
                && (!moment(item.dataBaseMulta, "MM/YYYY").isValid()
                    || !moment(item.dataBaseMulta, "MM/YYYY").isBetween('1901-01-01', moment())
                    || item.dataBaseMulta.length < 7)) {
                this.validations.dataBaseMulta.valid = false;
            }

            if(!this.verificarValorVazio(item.valorBasePrincipal) && this.verificarValorVazio(item.dataBasePrincipal)) {
                this.validations.dataBasePrincipal.required = false;
            }
            if(!this.verificarValorVazio(item.dataBasePrincipal) && this.verificarValorVazio(item.valorBasePrincipal)) {
                this.validations.valorBasePrincipal.required = false;
            }

            if(!this.verificarValorVazio(item.valorBaseMulta) && this.verificarValorVazio(item.dataBaseMulta)) {
                this.validations.dataBaseMulta.required = false;
            }
            if(!this.verificarValorVazio(item.dataBaseMulta) && this.verificarValorVazio(item.valorBaseMulta)) {
                this.validations.valorBaseMulta.required = false;
            }
        },
        fecharRecalcular() {
            this.hideModal('modal-editar');
        },
        salvarRecalcular() {
            this.existePgtoParcialAntesAjuizamento = false;

            for (let i = 0; i < this.subListaFiltro.length; i++) {
                if (this.subListaFiltro[i].codCdaSefa == this.itemEdicao[0].codCdaSefa) {
                    this.subListaFiltro[i].codCdaSefa = this.itemEdicao[0].codCdaSefa;
                    this.subListaFiltro[i].dataBaseMulta = this.itemEdicao[0].dataBaseMulta;
                    this.subListaFiltro[i].dataBasePrincipal = this.itemEdicao[0].dataBasePrincipal;
                    this.subListaFiltro[i].dataEnvio = this.itemEdicao[0].dataEnvio;
                    this.subListaFiltro[i].numeroDivida = this.itemEdicao[0].numeroDivida;
                    this.subListaFiltro[i].percentual = this.itemEdicao[0].percentual;
                    this.subListaFiltro[i].refisAtivo = this.itemEdicao[0].refisAtivo;
                    this.subListaFiltro[i].valorBaseHonorarios = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBaseHonorarios);
                    this.subListaFiltro[i].valorBaseMulta = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBaseMulta);
                    this.subListaFiltro[i].valorBasePrincipal = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorBasePrincipal);
                    this.subListaFiltro[i].valorJuros = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorJuros);
                    this.subListaFiltro[i].valorPendente = this.itemEdicao[0].valorPendente;

                    if(this.itemEdicao[0].valorBaseHonorarios != null) {
                        this.subListaFiltro[i].baseHonorariosFixo = true;
                    } else {
                        this.subListaFiltro[i].baseHonorariosFixo = false;
                    }

                    if(this.tipoEditar == 1) {
                        this.subListaFiltro[i].valorHonorariosFixo = true;
                        this.subListaFiltro[i].valorHonorarios = this.tratarCamposNumericosFloat(this.itemEdicao[0].valorHonorarios);
                        this.subListaFiltro[i].valorBasePrincipal = null;
                        this.subListaFiltro[i].valorBaseMulta = null;
                        this.subListaFiltro[i].valorJuros = null;
                        this.subListaFiltro[i].dataBasePrincipal = null;
                        this.subListaFiltro[i].dataBaseMulta = null;
                        this.subListaFiltro[i].valorBaseHonorarios = null;
                    } else {
                        this.subListaFiltro[i].valorHonorariosFixo = false;
                        this.subListaFiltro[i].valorHonorarios = this.itemEdicao[0].valorHonorarios;
                    }

                    this.subListaFiltro[i].calculoManual = true;

                    // editou a cda - retirar o flag existePgtoParcialAntesAjuizamento
                    this.subListaFiltro[i].pgtoParcialAntesAjuizamento = false;

                    this.calcularValorBaseHonorarios(this.subListaFiltro[i], false);
                } else 
                    if (this.subListaFiltro[i].pgtoParcialAntesAjuizamento) {
                        this.existePgtoParcialAntesAjuizamento = true;
                    }
            }
            this.requisicao.houveAlteracao = true;
            this.hideModal('modal-editar');
        },
        validarProximo() {
            if(this.$refs['modal-editar'].isShow){
                return false;
            }

            for(let i = 0; i < this.requisicao.cdas.length; i++) {
                if(this.verificarValorVazio(this.requisicao.cdas[i].valorHonorarios) || this.requisicao.cdas[i].valorHonorarios < 0) {
                    this.showModal('modal-info-error');
                    return false;
                }
            }

            if(this.requisicao.pagamento && !this.requisicao.pagamento.aVista &&
                (this.verificarValorVazio(this.requisicao.indiceReajuste) || this.verificarValorVazio(this.requisicao.numeroParcelas))) {
                this.exibirMensagem("Favor preencher os campos obrigatórios (*)");
                return false;
            }

            let resultado = true;
            this.validationsTela.sid.valid = true;
            if(this.requisicao.pagamento && this.requisicao.pagamento.delibSid && this.verificarValorVazio(this.requisicao.sid)) {
                this.validationsTela.sid.valid = false;
                this.validationsTela.sid.message = 'O campo SID é obrigatório.';
                resultado = false;
            }

            this.validationsTela.deliberacao.valid = true;
            if(this.requisicao.pagamento && this.requisicao.pagamento.delibSid && this.verificarValorVazio(this.requisicao.deliberacao)) {
                this.validationsTela.deliberacao.valid = false;
                this.validationsTela.deliberacao.message = 'O campo Nº Deliberação Conselho é obrigatório.';
                resultado = false;
            }

            return resultado;
        },
        nomeDevedorFormatado() {
            return this.requisicao.devedor.nome +
                (this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                    this.requisicao.devedor.documento != null && this.requisicao.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                this.requisicao.devedor.documento + ')';
        },
        async executarCalculos() {
            await axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/obterValoresAnterioresAtualizado/`, this.requisicao.cdas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.requisicao.cdas = response.data[0];
                this.deducoes = response.data[1];
                for(let i = 0; i < this.subListaFiltro.length; i++) {
                    for(let j = 0; j < this.requisicao.cdas.length; j++) {
                        if(this.subListaFiltro[i].codCdaSefa == this.requisicao.cdas[j].codCdaSefa) {
                            this.subListaFiltro[i] = this.requisicao.cdas[j];
                            break;
                        }
                    }
                }
            }).catch((error) => {
                this.exibirErro(error)
            });
        },
        async relatorioPDFDeducoes() {
            this.$refs.loadingTabela.showLoading();

	        let percentual = this.requisicao.boletoValorCerto ? 10 : this.tratarCamposNumericosFloat(this.requisicao.percentual);

            for (let j = 0; j < this.requisicao.cdas.length; j++) {
                this.requisicao.cdas[j].percentual = percentual;
            }

            let dadosDeducao = {
                devedor: this.requisicao.devedor,
                listaCdaSefaCalculoEfSefaVO: this.requisicao.cdas
            };

            axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/exportarRelatorioDeducoes/`, dadosDeducao, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'RelatorioDeducoes.pdf';
                    link.click();
                }).finally(() => {
                this.$refs.loadingTabela.hideLoading();
            })
        },
        limparFiltros(primeira) {
            this.filtros = {
                numeroDivida: null,
                refisAtivo: null,
                filtrarValorPendente: null,
                valorPendente: null,
                filtrarValorPrincipal: null,
                valorPrincipal: null,
                filtrarValorMulta: null,
                valorMulta: null,
                filtrarValorJuros: null,
                valorJuros: null,
                filtrarDataBasePrincipal: null,
                dataBasePrincipal: null,
                filtrarDataBaseMulta: null,
                dataBaseMulta: null,
                filtrarValorBase: null,
                valorBase: null,
                filtrarValorHonorarios: null,
                valorHonorarios: null,
                filtrarValorPercentualPago: null,
                valorPercentualPago: null,
                filtrarValorPercentual: null,
                valorPercentual: null,
            };

            this.consultar(primeira);
        },
        openFilter(campo, tipo, values, mascara, event) {
            if(document.getElementById('popup').style.display != 'block'
                || this.filtro.campoFiltro != campo) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'CDA') {
                    this.filtro.campoMascara = this.filtros.numeroDivida;
                } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                    this.filtro.campoRadio = this.filtros.refisAtivo;
                } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPendente;
                    this.filtro.campoTexto = this.filtros.valorPendente;
                } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPrincipal;
                    this.filtro.campoTexto = this.filtros.valorPrincipal;
                } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorMulta;
                    this.filtro.campoTexto = this.filtros.valorMulta;
                } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorJuros;
                    this.filtro.campoTexto = this.filtros.valorJuros;
                } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataBasePrincipal;
                    this.filtro.campoData = this.filtros.dataBasePrincipal;
                } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataBaseMulta;
                    this.filtro.campoData = this.filtros.dataBaseMulta;
                } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorBase;
                    this.filtro.campoTexto = this.filtros.valorBase;
                } else if(this.filtro.campoFiltro == 'Perc. Pend. (%)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPercentual;
                    this.filtro.campoTexto = this.filtros.valorPercentual;
                } else if(this.filtro.campoFiltro == 'Perc. Pago (%)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorPercentualPago;
                    this.filtro.campoTexto = this.filtros.valorPercentualPago;
                } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorHonorarios;
                    this.filtro.campoTexto = this.filtros.valorHonorarios;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$emit('atribuirFiltros', this.filtro);

                this.$emit('openCloseFilterPopup', event);
            } else {
                this.$emit('closeFilterPopup');
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'CDA') {
                this.filtros.numeroDivida = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.filtros.refisAtivo = this.filtro.campoRadio;
            } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                this.filtros.filtrarValorPendente = this.filtro.filtrarEm;
                this.filtros.valorPendente = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                this.filtros.filtrarValorPrincipal = this.filtro.filtrarEm;
                this.filtros.valorPrincipal = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                this.filtros.filtrarValorMulta = this.filtro.filtrarEm;
                this.filtros.valorMulta = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                this.filtros.filtrarValorJuros = this.filtro.filtrarEm;
                this.filtros.valorJuros = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                this.filtros.filtrarDataBasePrincipal = this.filtro.filtrarEm;
                this.filtros.dataBasePrincipal = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                this.filtros.filtrarDataBaseMulta = this.filtro.filtrarEm;
                this.filtros.dataBaseMulta = this.filtro.campoData;
            } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                this.filtros.filtrarValorBase = this.filtro.filtrarEm;
                this.filtros.valorBase = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Perc. Pago (%)') {
                this.filtros.filtrarValorPercentualPago = this.filtro.filtrarEm;
                this.filtros.valorPercentualPago = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Perc. Pend. (%)') {
                this.filtros.filtrarValorPercentual = this.filtro.filtrarEm;
                this.filtros.valorPercentual = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                this.filtros.filtrarValorHonorarios = this.filtro.filtrarEm;
                this.filtros.valorHonorarios = this.filtro.campoTexto;
            }

            this.configTable.currentPage = 1;

            this.consultar(false);
        },
        ordenarResultados(order) {
            if(this.filtro.campoFiltro == 'CDA') {
                this.configTable.sortField = 'numerodivida';
            } else if(this.filtro.campoFiltro == 'REFIS Ativo') {
                this.configTable.sortField = 'indrefis';
            } else if(this.filtro.campoFiltro == 'CDA Valor Pendente (R$)') {
                this.configTable.sortField = "valorPendente";
            } else if(this.filtro.campoFiltro == 'Valor Base Principal (R$)') {
                this.configTable.sortField = "valorPrincipal";
            } else if(this.filtro.campoFiltro == 'Valor Base Multa (R$)') {
                this.configTable.sortField = "valorMulta";
            } else if(this.filtro.campoFiltro == 'Juros Inscrito (R$)') {
                this.configTable.sortField = "valorJuros";
            } else if(this.filtro.campoFiltro == 'Data Base Principal') {
                this.configTable.sortField = "dataBasePrincipal";
            } else if(this.filtro.campoFiltro == 'Data Base Multa') {
                this.configTable.sortField = "dataBaseMulta";
            } else if(this.filtro.campoFiltro == 'Base Honorários (R$)') {
                this.configTable.sortField = "valorBaseHonorarios";
            } else if(this.filtro.campoFiltro == 'Perc. Pago (%)') {
                this.configTable.sortField = "valorPercentualPago";
            } else if(this.filtro.campoFiltro == 'Perc. Pend. (%)') {
                this.configTable.sortField = "valorPercentual";
            } else if(this.filtro.campoFiltro == 'Valor dos Honorários (R$)') {
                this.configTable.sortField = "valorHonorarios";
            }

            this.configTable.sortOrder = order;

            this.consultar(false);
        },
        onScroll(e) {
            var camposLine = document.getElementsByClassName("modalidadePagamento")[0].parentElement.parentElement;
            var commandLine = document.getElementById("btnAnteriorCalculos").parentElement.parentElement;
            var thColunas = document.getElementsByClassName("coluna-fixa-calculos")[0].parentElement.parentElement;

            var camposDeliberacao = document.getElementsByClassName("deliberacao")[0];
            if(camposDeliberacao != undefined) {
                camposDeliberacao = camposDeliberacao.parentElement.parentElement;
            }

            camposLine.style.position = 'sticky';
            camposLine.style.top = '59px';
            camposLine.style.zIndex = 2;
            camposLine.classList.add("background-scroller");

            var offserHeightDeliberacao = 0;
            if(camposDeliberacao != undefined) {
                camposDeliberacao.style.position = 'sticky';
                camposDeliberacao.style.top = (59 + camposLine.offsetHeight) + 'px';
                camposDeliberacao.style.zIndex = 2;
                camposDeliberacao.classList.add("background-scroller");
                offserHeightDeliberacao = camposDeliberacao.offsetHeight;
            }

            commandLine.style.position = 'sticky';
            commandLine.style.top = (59 + camposLine.offsetHeight + offserHeightDeliberacao) + 'px';
            commandLine.style.zIndex = 2;
            commandLine.classList.add("background-scroller");

            thColunas.style.position = 'sticky';
            thColunas.style.top = (58 + camposLine.offsetHeight + commandLine.offsetHeight + offserHeightDeliberacao) + 'px';
            commandLine.classList.add("sticky-header");
        },
        reiniciarValidations() {
            this.validations.valorBasePrincipal.valid = true;
            this.validations.valorBasePrincipal.required = true;
            this.validations.valorBaseMulta.valid = true;
            this.validations.valorBaseMulta.required = true;
            this.validations.valorJuros.valid = true;
            this.validations.valorBaseHonorarios.valid = true;
            this.validations.dataBasePrincipal.valid = true;
            this.validations.dataBasePrincipal.required = true;
            this.validations.dataBaseMulta.valid = true;
            this.validations.dataBaseMulta.required = true;
        },
        expandirTudo() {
            for(let i = 0; i < this.deducoes.resultado.length; i++) {
                if(!this.deducoes.resultado[i].expandido) {
                    this.$root.$emit('bv::toggle::collapse', 'accordion' + this.deducoes.resultado[i].id);
	                this.deducoes.resultado[i].expandido = true;
                }
            }
        },
        recolherTudo() {
            for(let i = 0; i < this.deducoes.resultado.length; i++) {
                if(this.deducoes.resultado[i].expandido) {
                    this.$root.$emit('bv::toggle::collapse', 'accordion' + this.deducoes.resultado[i].id);
	                this.deducoes.resultado[i].expandido = false;
                }
            }
        },
        calcularPercentualPendente(item) {
            if(item.percentualPago == null || item.percentualPago <= 0) {
                return item.percentual;
            }
            let percentual = this.toFixed(item.percentual - item.percentualPago);
            return Math.floor(percentual * 100) / 100;
        },
        abrirModalExtratoCda(numeroCda, codOrgaoOrigemDivida) {
            this.$emit('abrirExtratoCda', numeroCda, codOrgaoOrigemDivida);
        },
        formaPagamentoTitular() {
            let tempListaFormaPagamento = [];
            if (this.requisicao != null && this.requisicao.titularReceita == 0) {
                tempListaFormaPagamento.push(this.dados.formaPagamento[0]);
            } else {
                tempListaFormaPagamento.push(this.dados.formaPagamento[0]);
                //tempListaFormaPagamento.push(this.dados.formaPagamento[1]);
            }
            this.requisicao.formaPagamento = 1;
            
            return tempListaFormaPagamento;
        },
        iniciarValorCerto() {
	        if (this.requisicao.boletoValorCerto) {
		        this.requisicao.deduzirPagamentos = false;
		        this.consultar(false);
	        }
        },
        iniciarDeducoes() {
            if (this.requisicao.deduzirPagamentos) {
	            this.requisicao.boletoValorCerto = false;
                if (this.requisicao.titularReceita == 1 && this.requisicao.formaPagamento == 1) {
                    this.showModal('modal-deduzir-ces');
                } else {
                    this.showModal('modal-deduzir');
                }
            } else {
	            this.consultar(false);
            }
        },
        fecharModalAvisoDeducoes() {
	        this.consultar(false);
	        this.consultarDeducoes();
        },
        async consultarDeducoes() {
            if(!this.onLoadDeducoes && this.requisicao.deduzirPagamentos) {
                this.onLoadDeducoes = true;
                let perPageStr = `&perPage=${this.configTableDeducoes.perPage}`;
                if (this.configTableDeducoes.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTableDeducoes.currentPage = 1;
                    this.configTableDeducoes.rows = 0;
                }
                if(!this.configTableDeducoes.iniciada) {
                    this.configTableDeducoes.perPage = 10;
                    this.configTableDeducoes.currentPage = 1;

                    this.filtros.listaCdaSefaCalculoEfSefaVO = [];
                    for (let j = 0; j < this.cdasSelecionadas.length; j++) {
                        this.filtros.listaCdaSefaCalculoEfSefaVO.push({
                            codCdaSefa: this.cdasSelecionadas[j].codCdaSefa,
                            codProcesso: this.cdasSelecionadas[j].codProcesso,
                            dataAjuizamento: this.cdasSelecionadas[j].dataAjuizamento,
                            dataBasePrincipal: this.cdasSelecionadas[j].dataBasePrincipal,
                            dataBaseMulta: this.cdasSelecionadas[j].dataBaseMulta,
                            valorPendente: this.cdasSelecionadas[j].valor,
                            valorBasePrincipal: this.cdasSelecionadas[j].valorBasePrincipal,
                            valorBaseMulta: this.cdasSelecionadas[j].valorBaseMulta,
                            valorJuros: this.cdasSelecionadas[j].valorJuros,
                            dataBasePrincipalAtual: this.cdasSelecionadas[j].dataBasePrincipalAtual,
                            dataBaseMultaAtual: this.cdasSelecionadas[j].dataBaseMultaAtual,
                            valorBasePrincipalAtual: this.cdasSelecionadas[j].valorBasePrincipalAtual,
                            valorBaseMultaAtual: this.cdasSelecionadas[j].valorBaseMultaAtual,
                            valorJurosAtual: this.cdasSelecionadas[j].valorJurosAtual,
                            tipoCredito: this.cdasSelecionadas[j].tipoCredito,
                            situacao: this.cdasSelecionadas[j].situacao,
                            numeroDivida: this.cdasSelecionadas[j].numeroDivida,
                            refisAtivo: this.cdasSelecionadas[j].refisAtivo,
                            cnj: this.cdasSelecionadas[j].cnj,
                            calculoManual: this.cdasSelecionadas[j].calculoManual,
                            percentual: this.tratarCamposNumericosFloat(this.requisicao.percentual),
                            listaHonorariosExecucaoFiscalSefa: this.cdasSelecionadas[j].listaHonorariosExecucaoFiscalSefa
                        });
                    }
                } else {
                    for (let j = 0; j < this.requisicao.cdas.length; j++) {
                        this.requisicao.cdas[j].percentual = this.tratarCamposNumericosFloat(this.requisicao.percentual);
                    }
                    this.filtros.listaCdaSefaCalculoEfSefaVO = this.requisicao.cdas;
                }

                this.filtros.deduzirPagamentos = this.requisicao.deduzirPagamentos;
                this.filtros.listaCodFichaProcesso = [];
                for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                    this.filtros.listaCodFichaProcesso.push(this.cdasSelecionadas[i].codCdaSefa);
                }

                this.configTableDeducoes.load = true;
                axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/consultarDeducoes?page=${this.configTableDeducoes.currentPage}${perPageStr}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.deducoes = response.data;
                    this.configTableDeducoes.iniciada = true;
                    if (this.configTableDeducoes.perPage !== 'Todos') {
                        this.configTableDeducoes.rows = response.data.rows;
                        this.configTableDeducoes.lastPage = Math.ceil(this.configTableDeducoes.rows / this.configTableDeducoes.perPage);
                    } else {
                        this.configTableDeducoes.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTableDeducoes.load = false;
                    this.onLoadDeducoes = false;
                })
            }
        },
        async atualizarBarraProgresso(futureName) {
            this.filtros.listaCdaSefaCalculoEfSefaVO = this.requisicao.cdas;

            this.configTable.load = true;
            axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/verificarAndamentoCalculos/${futureName}`, this.filtros, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': this.token
              }
            }).then(response => {
              this.maximoCalculos = response.data.totalRegistros;
              this.calculosRealizados = response.data.registrosSalvos;

              if(response.data.finalizado) {
                this.onLoad = false;
                this.consultar(false);
              } else {
                setTimeout(() => {
                  this.atualizarBarraProgresso(futureName);
                }, 2500);
              }
            }).catch((error) => {
              this.exibirErro(error);
              this.hideModal('modal-barra-progresso');
              this.configTable.load = false;
              this.onLoad = false;
            })
        },
        carregarDadosSelic() {
            axios.get(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/obterValoresSelic`, {
	            headers: {
	              'Content-Type': 'application/json',
	              'Authorization': this.token
	            }
            }).then(response => {
                if (response.data != null && response.data != "") {
	                for(let i = 0; i < response.data.length; i++) {
		                this.indiceList.push({
			                data: response.data[i].ano + '' + (response.data[i].mes < 10 ? '0' : '') + response.data[i].mes,
			                variacao: response.data[i].variacao
		                });
	                }
                }
            });
        },
	    validarValor() {
		    let valor = this.tratarCamposNumericos(this.requisicao.valorCerto)
		    if(valor <= 0) {
			    this.validations.valor.valid = false;
		    } else {
			    this.validations.valor.valid = true;
		    }
	    },

        async relatorioPDFSimulacaoCalculo() {
            this.$refs.loadingTabela.showLoading();

	        let percentual = this.requisicao.boletoValorCerto ? 10 : this.tratarCamposNumericosFloat(this.requisicao.percentual);

            for (let j = 0; j < this.requisicao.cdas.length; j++) {
                this.requisicao.cdas[j].percentual = percentual;
            }

            let dadosSimulacaoCalculo = {
                honorarioEfSefaVO: this.requisicao,
                listaCdaSefaCalculoEfSefaVO: this.requisicao.cdas,
                subfluxo1: true

            };

            axios.post(`${this.urlApi}/v1/honorariosExecucaoFiscalSefa/exportarRelatorioSimulacaoCalculo/`, dadosSimulacaoCalculo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'RelatorioSimulacaoCalculo.pdf';
                    link.click();
                }).finally(() => {
                this.$refs.loadingTabela.hideLoading();
            })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();
        this.listarRegrasPagamento();
        this.listarIndiceReajuste();
        this.carregarDadosSelic();

        window.addEventListener("scroll", this.onScroll);

        this.$root.$on('bv::collapse::state', (id, expandido) => {
            for(let i = 0; i < this.deducoes.length; i++) {
                if(id == 'accordion' + this.deducoes[i].id) {
                    this.deducoes[i].expandido = expandido;
                }
            }
        })
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll)
    },

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>

<style>

.sticky-header:hover {
    z-index: 2;
}

</style>
